import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useContact from 'flow/hooks/useContact';
import useCustomer from 'flow/hooks/useCustomer';
import { getCoListeningRemotePartyNumber, selectActiveCallOfContact } from 'flow/selectors/call-selectors';
import { getCoListeningContact } from 'flow/selectors/contact-selectors';
import { lookupNumber } from 'flow/actions/contact-actions';
import { generatePath } from 'flow/utils/router-utils';
import { routes } from 'flow/types/routes';
import { getExtensionFromContactKey } from 'flow/selectors/selectors';
import CoListeningSupervisorLarge from './CoListeningSupervisorLarge';
import CoListeningSupervisorSmall from './CoListeningSupervisorSmall';
import { addUserPhoneLogEntry } from 'flow/utils/browser-utils';
import { getCountryCode } from 'flow/utils/extension-utils';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { jsx as _jsx } from "react/jsx-runtime";
var CoListeningSupervisorWrapper = function CoListeningSupervisorWrapper(_ref) {
  var subjectContact = _ref.subjectContact,
    subjectNumber = _ref.subjectNumber,
    startTime = _ref.startTime,
    onHangup = _ref.onHangup,
    itemSize = _ref.itemSize;
  var dispatch = useAppDispatch();
  var history = useHistory();
  var _useContact = useContact(),
    ownContact = _useContact.ownContact;
  var _useCustomer = useCustomer(),
    ownCustomer = _useCustomer.ownCustomer;
  var ownCountryCode = getCountryCode(ownContact, ownCustomer);
  var fetchedSubjectContact = useAppSelector(function (state) {
    return getCoListeningContact(state, subjectNumber, subjectContact, ownCountryCode);
  });
  var remotePartyOfSubjectNumber = useAppSelector(function (state) {
    return getCoListeningRemotePartyNumber(state, fetchedSubjectContact === null || fetchedSubjectContact === void 0 ? void 0 : fetchedSubjectContact.get('key'));
  });
  var remotePartyOfSubjectContact = useAppSelector(function (state) {
    return getCoListeningContact(state, remotePartyOfSubjectNumber, null, ownCountryCode);
  });
  var activeCallOfSubject = useAppSelector(function (state) {
    return selectActiveCallOfContact(state, fetchedSubjectContact === null || fetchedSubjectContact === void 0 ? void 0 : fetchedSubjectContact.get('key'));
  });
  var subjectExtension = useAppSelector(function (state) {
    return getExtensionFromContactKey(state, fetchedSubjectContact === null || fetchedSubjectContact === void 0 ? void 0 : fetchedSubjectContact.get('key'));
  });
  useEffect(function () {
    if (subjectNumber && !fetchedSubjectContact) {
      addUserPhoneLogEntry("Doing numberlookup on ".concat(subjectNumber));
      dispatch(lookupNumber(subjectNumber));
    }
  }, [subjectNumber, lookupNumber, fetchedSubjectContact]);
  useEffect(function () {
    if (remotePartyOfSubjectNumber && !remotePartyOfSubjectContact) {
      addUserPhoneLogEntry("Doing numberlookup on ".concat(remotePartyOfSubjectNumber));
      dispatch(lookupNumber(remotePartyOfSubjectNumber));
    }
  }, [remotePartyOfSubjectNumber, lookupNumber, remotePartyOfSubjectContact]);
  var handleChat = function handleChat() {
    history.push(generatePath(routes['messages.id.redirect'], {
      chatUserKey: subjectExtension === null || subjectExtension === void 0 ? void 0 : subjectExtension.get('chatUserKey')
    }));
  };
  var coListeningComponentProps = {
    subjectContact: subjectContact,
    subjectNumber: subjectNumber,
    remotePartyOfSubjectContact: remotePartyOfSubjectContact,
    remotePartyOfSubjectNumber: remotePartyOfSubjectNumber,
    ownCountryCode: ownCountryCode,
    startTime: startTime,
    onHangup: onHangup,
    activeCallOfSubject: activeCallOfSubject,
    handleChat: subjectExtension ? handleChat : null
  };
  return itemSize === 'large' ? /*#__PURE__*/_jsx(CoListeningSupervisorLarge, _objectSpread({}, coListeningComponentProps)) : /*#__PURE__*/_jsx(CoListeningSupervisorSmall, _objectSpread({}, coListeningComponentProps));
};
export default CoListeningSupervisorWrapper;